export default "__VITE_ASSET__DMV2PMiU__"